// Author liang gang qiang
// Date 2021-11-24 16:34:50

class MintalMesPrdMaterialRequirePlan {
constructor({
        id = null,
        code = '',
        locationId = '',
        month = '',
        materialId = '',
        planRate = '',
        quantity = '',
        unit = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.locationId = locationId;
    this.month = month;
    this.materialId = materialId;
    this.planRate = planRate;
    this.quantity = quantity;
    this.unit = unit;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdMaterialRequirePlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'month',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.month',
        sortable: true,
        form: {
        type: 'year_month'
        }
        },
        {
        key: 'materialName',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.materialName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planRate',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.planRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'quantity',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.quantity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    locationIdFilter : '',
    monthRteFilter : '',
    monthLteFilter : '',
    materialIdFilter : '',
    planRateFilter : '',
    quantityFilter : '',
    unitFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'locationIdFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.locationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'monthRteFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.monthRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'monthLteFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.monthLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'materialIdFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.materialId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'planRateFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.planRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'month',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.month',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'materialId',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.materialId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstMaterial'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'planRate',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.planRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'quantity',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'unit',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdMaterialRequirePlan.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdMaterialRequirePlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
